import { createContext, useContext, ReactNode } from 'react';

/** Main app tab indices (must match `mainTabs` order in App.tsx when workflow is entered). */
export const MAIN_TAB = {
  dashboard: 0,
  registration: 1,
  preConsultation: 2,
  patientVisit: 3,
  /** Main app tab label: "Management" (form tab key remains Prescription). */
  management: 4,
  billing: 5,
} as const;

interface MainTabContextValue {
  navigateToTabIndex: (index: number) => void;
  ensureWorkflowEntered: () => void;
}

const MainTabContext = createContext<MainTabContextValue | null>(null);

export function MainTabProvider({
  children,
  navigateToTabIndex,
  ensureWorkflowEntered,
}: {
  children: ReactNode;
  navigateToTabIndex: (index: number) => void;
  ensureWorkflowEntered: () => void;
}) {
  return (
    <MainTabContext.Provider value={{ navigateToTabIndex, ensureWorkflowEntered }}>
      {children}
    </MainTabContext.Provider>
  );
}

export function useMainTab() {
  const ctx = useContext(MainTabContext);
  if (!ctx) {
    throw new Error('useMainTab must be used within MainTabProvider');
  }
  return ctx;
}
